// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  googleMapsAPIKey: 'AIzaSyAXfLeaTDAx8UEJjdfr1J0GzYZKstHrjow',
  firebaseAPIKey: 'AIzaSyAnKihJ_3_2AxZchRbNk8w7-zZpzG9PuZM',
  firebaseConfig: {
    apiKey: "AIzaSyAnKihJ_3_2AxZchRbNk8w7-zZpzG9PuZM",
    authDomain: "hunterface-27c9f.firebaseapp.com",
    databaseURL: "https://hunterface-27c9f-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "hunterface-27c9f",
    storageBucket: "hunterface-27c9f.appspot.com",
    messagingSenderId: "83171745671",
    appId: "1:83171745671:web:b17018b06cca775d1fbd22",
    measurementId: "G-MB6QC3E1ED"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
